export default () => {
  const sliderParents = document.querySelectorAll(
    '.js-slider-relevant-container'
  )

  if (sliderParents.length < 1) return
  ;[...sliderParents].forEach(sliderParent => {
    // Variables

    const slider = sliderParent.querySelector('.js-slider')
    const slides = sliderParent.querySelectorAll('.js-slide')
    const next = sliderParent.querySelector('.js-next')
    const prev = sliderParent.querySelector('.js-prev')
    let slidesCount = slides.length - 2
    const firstSlide = slides[0]

    if (slides.length < 1) return

    let pos = 0

    ;[...slides].forEach(slide => {
      if (sliderParent.offsetWidth < 736) {
        slide.style.width = '' + sliderParent.offsetWidth * 0.85 + 'px'
      } else if (sliderParent.offsetWidth < 1300) {
        slide.style.width = '' + sliderParent.offsetWidth / 3 - 12 + 'px'
        slidesCount = slides.length - 2
      } else {
        slide.style.width = '' + sliderParent.offsetWidth / 4 - 12 + 'px'
        slidesCount = slides.length - 3
      }
    })

    let slideWidth =
      firstSlide.offsetWidth +
      parseFloat(getComputedStyle(firstSlide).marginRight)
    slider.style.width = '' + slideWidth * slides.length + 'px'

    prev.style.display = 'none'

    // Events
    prev.addEventListener('click', () => {
      goPrev()
    })

    next.addEventListener('click', () => {
      goNext()
    })

    document.addEventListener('keydown', e => {
      if (e.keyCode === 39) {
        goNext()
      }
      if (e.keyCode === 37) {
        goPrev()
      }
    })

    //functions
    function goPrev() {
      console.log('prev')
      if (pos > 0) {
        pos--
        navActivity(pos)
      }
    }

    function goNext() {
      console.log('next')
      if (pos < slidesCount - 1) {
        pos++
        navActivity(pos)
      }
    }

    function navActivity(pos) {
      slider.style.transform = 'translateX(-' + slideWidth * pos + 'px)'

      if (pos === 0) {
        prev.style.display = 'none'
      } else {
        prev.style.display = 'flex'
      }

      if (pos === slidesCount - 1) {
        next.style.display = 'none'
      } else {
        next.style.display = 'flex'
      }
    }
  }) // end foreach
}



// WEBPACK FOOTER //
// ./src/js/modules/RelevantSlider.js